import { store } from "../../../redux/store.js";
import { selectUser } from "../../../redux/user/user.slice.js";
import { getFbBrand, login, setCurrentUser } from "../../../redux/user/user.thunk.js";
import { auth } from "./firebase.js";

let listenerAttached = false;
let hashLoginDispatched = false;

const devLog = (...args) => {
    if (process.env.NODE_ENV === "development") {
        console.log("[smi/auth]", ...args);
    }
};

const parseCustomAttributes = (firebaseUser) => {
    try {
        const rawCustomAttributes = firebaseUser?.reloadUserInfo?.customAttributes;
        return rawCustomAttributes ? JSON.parse(rawCustomAttributes) : {};
    } catch (e) {
        return {};
    }
};

const isSameUserSession = (currentUser, firebaseUser, role, brandId) => {
    if (!currentUser || !firebaseUser) return false;
    const currentUid = currentUser?.uid || currentUser?.localId;
    const nextUid = firebaseUser?.uid || firebaseUser?.localId;
    const currentKey =
        currentUser?.brand?.brandId != null && currentUser?.brand?.brandId !== ""
            ? String(currentUser.brand.brandId)
            : "";
    const nextKey = brandId != null && brandId !== "" ? String(brandId) : "";
    return currentUid === nextUid && currentUser?.role === role && currentKey === nextKey;
};

const onAuthUser = (userData) => {
    if (userData) {
        const firebaseUser = userData?.multiFactor?.user || userData;
        const hash = typeof window !== "undefined" ? window.location.hash : "";
        const brandIdFromHash = hash ? hash.slice(1).split("__")[0] : null;
        if (brandIdFromHash) {
            localStorage.setItem("brandId", brandIdFromHash);
        }
        localStorage.setItem("userToken", firebaseUser?.accessToken || "");
        firebaseUser
            .getIdTokenResult()
            .then((idTokenResult) => {
                const state = store.getState();
                const user = selectUser(state)?.user;
                const claims = idTokenResult?.claims || {};
                const customAttributes = parseCustomAttributes(firebaseUser);
                const brandId = customAttributes?.brandId ?? claims?.brandId ?? null;
                let idForBrandFetch = null;
                if (brandId != null && brandId !== "") {
                    const idStr = String(brandId);
                    localStorage.setItem("brandId", idStr);
                    if (!isSameUserSession(user, firebaseUser, "brand", brandId)) {
                        store.dispatch(
                            setCurrentUser({
                                ...firebaseUser,
                                brand: {brandId: idStr},
                                role: "brand",
                            })
                        );
                    }
                    idForBrandFetch = idStr;
                } else {
                    const adminBrandId = localStorage.getItem("brandId");
                    if (!isSameUserSession(user, firebaseUser, "admin", adminBrandId)) {
                        store.dispatch(
                            setCurrentUser({
                                ...firebaseUser,
                                brand: adminBrandId ? {brandId: String(adminBrandId)} : {},
                                role: "admin",
                            })
                        );
                    }
                    if (adminBrandId) idForBrandFetch = String(adminBrandId);
                }
                if (idForBrandFetch) {
                    devLog("dispatch getFbBrand", {
                        idForBrandFetch,
                        role: brandId != null && brandId !== "" ? "brand" : "admin",
                    });
                    store.dispatch(getFbBrand(idForBrandFetch));
                } else {
                    devLog("skip getFbBrand (no brand id)");
                }
            })
            .catch((err) => console.warn("[useAuth] getIdTokenResult", err));
    } else {
        localStorage.removeItem("userToken");
        localStorage.removeItem("brandId");
        store.dispatch(setCurrentUser(null));
    }
};

/**
 * Un seul listener Firebase Auth pour toute l’app (évite les appels API / Redux en double
 * quand plusieurs composants utilisaient useAuth).
 */
export function ensureFirebaseAuthListener() {
    if (listenerAttached) return;
    listenerAttached = true;
    auth.onAuthStateChanged(onAuthUser);
}

export function maybeDispatchHashLogin() {
    if (hashLoginDispatched) return;
    const hash = typeof window !== "undefined" ? window.location.hash : "";
    if (!hash || hash.length <= 50) return;
    hashLoginDispatched = true;
    store.dispatch(login({ token: hash }));
}
